<template>
    <div class="question-signature-type">
        <div v-if="hasError">
            <b-alert show variant="danger">{{ errorText }}</b-alert>
        </div>
        <b-form-group
            id="custom-form-question-signature"
            class="custom-form-question-signature-group"
            label-for="custom-form-question-signature">
            <template v-slot:label>
                {{ questionIn.text }}: <span class="required" v-if="questionIn.required">*</span>
            </template>

                <VueSignaturePad
                    class="signature-wrapper"
                    width="700px"
                    height="300px"
                    ref="signaturePad"
                    :options="{ onEnd }"/>

                <b-button
                    class="btn-redo btn-reset-signature"
                    variant="primary-icon-only"
                    @click="reset"
                    v-b-tooltip.hover="'Reset'">
                </b-button>

        </b-form-group>
    </div>
</template>

<script>
export default {
    name: "custom-form-create-question-signature-component",
    props:{
        questionIn: {
            type: Object,
            required: true,
        },
        hasError: {
            type: Boolean,
            required: false,
            default: false,
        },
        errorText: {
            type: String,
            required: false,
            default: 'Deze vraag is verplicht.'
        },
        value: {
            type: Object,
        },
    },
    methods:{
        reset(){
            this.$refs.signaturePad.clearSignature();
            this.$emit('update-answer', {
                questionId: this.questionIn.id,
                value: null,
                isEmpty: true,
                type: 5
            });
        },
        onEnd() {
            this.$emit('update-answer', {
                questionId: this.questionIn.id,
                value: this.$refs.signaturePad.saveSignature(),
                isEmpty: false,
                type: 5
            });
        }
    },
    mounted() {
        if (this.value) {
            this.$nextTick(() => {
                this.$refs.signaturePad.fromDataURL(this.value.data);
            })
        }
    }
}
</script>

<style scoped lang="scss">
    .signature-wrapper {
        border: 1px solid $border-color;
        border-radius: 4px;
        max-width: 100%;
        height: 125px;
    }

    .custom-form-question-signature-group ::v-deep{
        > div {
            display: flex;
            flex: 1;
            flex-direction: column;
            column-gap: map-get($grid-gutter-spacing, 'fifteen');
            align-items: flex-start;
        }
    }

    .btn-reset-signature {
        font-size: 0.75rem;
        margin-top: map-get($grid-gutter-spacing, 'ten');
        margin-left: 0;
        align-self: flex-end;

        &:before {
            margin-right: 0;
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'sm')){
        .btn-reset-signature {
            margin-top: 0;
            margin-left: map-get($grid-gutter-spacing, 'ten');
            align-self: flex-start;
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'md')){
        .custom-form-question-signature-group ::v-deep {
            > div {
                flex-direction: row;
            }
        }

        .signature-wrapper {
            width: 300px;
        }
    }
</style>
